module.exports = __webpack_public_path__ + "img/chest4_open.a0e63b15.png";